import { render, staticRenderFns } from "./ComplaintForm.vue?vue&type=template&id=6acae3be&scoped=true&"
import script from "./ComplaintForm.vue?vue&type=script&lang=js&"
export * from "./ComplaintForm.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintForm.vue?vue&type=style&index=0&id=6acae3be&lang=scss&scoped=true&"
import style1 from "./ComplaintForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acae3be",
  null
  
)

export default component.exports